import DataRujukan from "@/services/DataRujukan";
import { appModule } from "./app";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

export interface JawabanRujukanState {
  jawabanRujukan: JawabanRujukan[];
  detailJawabanRujukan: JawabanRujukan
}

interface JawabanRujukan {
  id: number;
  tgl_surat: string
  register_id: number;
  pasien_rm: string
  dokter: object;
  dokter_tujuan: string
  faskes_tujuan: object;
  diagnosis: any;
  terapi: any;
  saran: any;
  signed: number;
  signature: Array<object>;
}

interface FaskesCostum {
  id: string
  nama: string
}


@Module({ store, dynamic: true, name: "storeJawabanRujukan" })
class JawabanRujukanStore extends VuexModule implements JawabanRujukanState {
  detailJawabanRujukan = {} as JawabanRujukan
  jawabanRujukan: JawabanRujukan[] = [];
  isloading: boolean
  faskesCustom: FaskesCostum[] = []

  @Mutation SET_JAWABAN_RUJUKAN(jawabanRujukan: JawabanRujukan[]) {
    this.jawabanRujukan = jawabanRujukan;
  }
  @Mutation SET_DETAIL_JAWABAN_RUJUKAN(detailJawabanRujukan: JawabanRujukan) {
    this.detailJawabanRujukan = detailJawabanRujukan;
  }

  @Action actJawabanRujukan_on_reg(reg) {
    const dt = DataRujukan.getDataJawabanRujukanReg(reg);
    appModule.setLoading(true);
    dt.then(dt => {
      appModule.setLoading(false);
      const detail = dt.data
      this.SET_JAWABAN_RUJUKAN(dt)
      this.SET_DETAIL_JAWABAN_RUJUKAN(detail)
    });

    // const detail = [{
    //   id: 1,
    //   tgl_surat: "2021-04-12",
    //   register_id: 20068131,
    //   pasien_rm: "403852",
    //   dokter: { id: 428, nama: "dr. I NYOMAN TRITIA WIDIANTARA, Sp. OG" },
    //   dokter_tujuan: "dr. blangkon",
    //   faskes_tujuan: { id: 1, nama: "RS Sardjito" },
    //   diagnosis: "ASS",
    //   terapi: "terapi",
    //   saran: "saran",
    //   signed: 0,
    //   signature: []
    // signature: [{
    //   user: {
    //     id: 428,
    //     nama: "dr. I NYOMAN TRITIA WIDIANTARA, Sp. OG"
    //   },
    //   note: null,
    //   created_at: "2021-04-12 11:50:25"
    // }]

    // }]
    // const hh = []
    // this.SET_JAWABAN_RUJUKAN(detail)
    // this.SET_DETAIL_JAWABAN_RUJUKAN(detail[0])

    // const hh = []
    // const mm = { status: 1, data: [] }
    // this.SET_JAWABAN_RUJUKAN([])
    // this.SET_DETAIL_JAWABAN_RUJUKAN(hh[0])
  }


  @Mutation SET_CUSTOM(faskesCustom: FaskesCostum[]) {
    this.faskesCustom = faskesCustom;
  }

  @Action act_autocomplete_faskes_custom(term: string) {
    // console.log('term',term)
    const dt = DataRujukan.getDataFaskesCustom(term)
    dt.then(dt => {
      const faskesCustom = dt
      // const status = dt.status
      this.SET_CUSTOM(faskesCustom);
    });
  }
}

export const storeJawabanRujukan = getModule(JawabanRujukanStore);
